import { Box, Grid } from "@mui/material";
import useIsCreate from "hooks/useIsCreate";
import VacancyForm from "./VacancyForm";
import Controls from "./Controls";
import { VacancyCompanyCandidatesRefetch } from "../types";

interface ContentProps {
  vacancyCompanyCandidatesRefetch: VacancyCompanyCandidatesRefetch | null;
}

const Content = ({ vacancyCompanyCandidatesRefetch }: ContentProps) => {
  const isCreate = useIsCreate();

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        p: 2.5,
      }}>
      <Grid
        container
        spacing={2.5}>
        <Grid
          item
          xs={12}
          md={6}>
          <VacancyForm />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}>
          {!isCreate && <Controls vacancyCompanyCandidatesRefetch={vacancyCompanyCandidatesRefetch} />}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Content;
